import { useState } from "react";
import { Calendar } from "lucide-react";

const QUICK = [
  { key: "today", label: "Aujourd'hui" },
  { key: "yesterday", label: "Hier" },
  { key: "week", label: "Cette semaine" },
  { key: "month", label: "Ce mois" },
];

const ADV = [
  { key: "day", label: "Jour précis" },
  { key: "week_of", label: "Semaine précise" },
  { key: "month_of", label: "Mois précis" },
  { key: "custom", label: "Plage personnalisée" },
];

export function buildPeriodQuery(p) {
  const q = new URLSearchParams({ period: p.period });
  if (p.period === "day" || p.period === "week_of") q.set("date", p.date || "");
  if (p.period === "month_of") { q.set("month", p.month || ""); q.set("year", p.year || ""); }
  if (p.period === "custom") { q.set("start", p.start || ""); q.set("end", p.end || ""); }
  return q.toString();
}

export function PeriodFilter({ value, onChange }) {
  const [p, setP] = useState(value || { period: "month" });
  const today = new Date().toISOString().slice(0, 10);

  const apply = (next) => { const merged = { ...p, ...next }; setP(merged); onChange(merged); };

  return (
    <div className="tm-card p-3 mb-6 flex flex-wrap items-center gap-2" data-testid="period-filter">
      <span className="flex items-center gap-1.5 text-xs uppercase tracking-wider text-[var(--tm-muted)] mr-1"><Calendar size={14} /> Période</span>
      {QUICK.map((q) => (
        <button key={q.key} onClick={() => apply({ period: q.key })} data-testid={`period-${q.key}`}
          className="px-3 py-1.5 rounded-md text-sm font-semibold transition-colors"
          style={p.period === q.key ? { background: "#D4AF37", color: "#000" } : { background: "var(--tm-surface-2)", color: "var(--tm-muted)" }}>
          {q.label}
        </button>
      ))}
      <select className="tm-input py-1.5 text-sm" style={{ width: "auto" }} value={ADV.some((a) => a.key === p.period) ? p.period : ""}
        onChange={(e) => { const k = e.target.value; if (!k) return; apply({ period: k, date: today, month: String(new Date().getMonth() + 1), year: String(new Date().getFullYear()), start: today, end: today }); }}
        data-testid="period-advanced">
        <option value="">Avancé…</option>
        {ADV.map((a) => <option key={a.key} value={a.key}>{a.label}</option>)}
      </select>

      {(p.period === "day" || p.period === "week_of") && (
        <input type="date" className="tm-input py-1.5 text-sm" style={{ width: "auto" }} value={p.date || today} onChange={(e) => apply({ date: e.target.value })} data-testid="period-date" />
      )}
      {p.period === "month_of" && (
        <input type="month" className="tm-input py-1.5 text-sm" style={{ width: "auto" }} value={`${p.year || new Date().getFullYear()}-${String(p.month || new Date().getMonth() + 1).padStart(2, "0")}`}
          onChange={(e) => { const [y, m] = e.target.value.split("-"); apply({ year: y, month: String(parseInt(m, 10)) }); }} data-testid="period-month-input" />
      )}
      {p.period === "custom" && (
        <span className="flex items-center gap-2">
          <input type="date" className="tm-input py-1.5 text-sm" style={{ width: "auto" }} value={p.start || today} onChange={(e) => apply({ start: e.target.value })} data-testid="period-start" />
          <span className="text-[var(--tm-muted)]">→</span>
          <input type="date" className="tm-input py-1.5 text-sm" style={{ width: "auto" }} value={p.end || today} onChange={(e) => apply({ end: e.target.value })} data-testid="period-end" />
        </span>
      )}
    </div>
  );
}
